export default {
  SET_LOADED(state, payload) {
    state.loaded = payload;
  },

  IS_MOBILE(state, payload) {
    state.mobile = payload;
  },

  IS_TOUCH(state, payload) {
    state.touch = payload;
  },

  TOGGLE_MENU(state) {
    state.menu = !state.menu;
  },

  SET_DETAIL(state, payload) {
    state.detail = payload;
  },

  SET_DATA(state, payload) {
    state.firebase = payload;
  },

  FORM_STATUS(state, payload) {
    state.formStatus = payload;
  },

  NEXT_TYPE(state, payload) {
    state.nextType = payload;
  },
};
